import {Injectable} from 'ng-metadata/core';
import { ICDCollectionObject } from '../collectionDiscovery.service';

@Injectable()
export class CollectionGalleryService {

    private _isGalleryLobby: boolean;

    set isGalleryLobby(isGalleryLobby) {
        this._isGalleryLobby = isGalleryLobby;
    }

    get isGalleryLobby() {
        return this._isGalleryLobby;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/collectionDiscovery/collectionGallery/collectionGallery.service.ts